function moveHexUp(level) {
  if ($('.hex-'+level).hasClass('hex-1') || $('.hex-btn.level-'+level).hasClass('locked')) {
    return false;
  }

  $('.hex-btn').addClass('locked');

  if ($('.hex-'+level).hasClass('hex-2')) {
    $('.hex-'+level).addClass('hex-0');
    $('.hex-1').addClass('hex-2').removeClass('hex-1');
  } else {
    $('.hex-'+level).addClass('hex-0');
    $('.hex-2').addClass('hex-3').removeClass('hex-2');
    $('.hex-1').addClass('hex-2').removeClass('hex-1');
  }

  setTimeout(() => {
    $('.hex-'+level).removeClass('hex-0 hex-2 hex-3').addClass('hex-1');
    $('.hex-btn').removeClass('locked');
  }, 500);


  $('.hex-btn._current').removeClass('_current');
  $('.hex-btn.level-'+level).addClass('_current');
}
